import React, { createContext, useContext, useState, useEffect } from "react";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem("wishlist")) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("wishlist", JSON.stringify(ids)); }, [ids]);

  const toggle = (id) => setIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  const has = (id) => ids.includes(id);
  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, remove, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
